export const Constants = {
  API_DEV: 'http://localhost:3500/',
  API_STAGING: 'https://staging.api.evchargersnetwork.com/'
};

export const WEBSOCKET_EVENTS = {
  // Keep legacy key for backward compatibility
  WEBSOCKET_IO_DISCONNECT: 'io server disconnect',
  WEBSOCKET_IO_SERVER_DISCONNECT: 'io server disconnect',
  WEBSOCKET_IO_CLIENT_DISCONNECT: 'io client disconnect',
  WEBSOCKET_DISCONNECT: 'disconnect',
  WEBSOCKET_CONNECT: 'connect',
  WEBSOCKET_CONNECT_ERROR: 'connect_error'
};

export const RFID_TAG_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
};

export const SESSION_START_TYPE = {
  WEB: 'WEB',
  RFID: 'RFID',
  POS: 'POS'
};

export const BREAKPOINTS = {
  mobileBreakpoint: 1024
};

export const ORGANIZATION_TYPE = {
  BASE: 'BASE',
  PROVIDER: 'PROVIDER'
};

export const CHARGING_STATES = {
  AVAILABLE: 'AVAILABLE',
  CONNECTING: 'CONNECTING',
  PREPARING: 'PREPARING',
  OFFLINE: 'OFFLINE',
  FINISHING: 'FINISHING',
  COMPLETED: 'COMPLETED',
  CHARGING: 'CHARGING',
  SUSPENDED_EV: 'SUSPENDED_EV'
};

export const ROLES = {
  ADMIN: 'ADMIN',
  SUPER_ADMIN: 'SUPER ADMIN',
  USER: 'USER'
};

export const CHART_INTERVAL = {
  min_5: 1000 * 60 * 5, // every 5 min
  hour_1: 60000 * 60, // every hour
  hour_6: 60000 * 60 * 6, // every 6 hours
  day_1: 60000 * 60 * 24 // every day
};

export const DATE_FORMAT = {
  hour: '%H:%M:%S',
  day: '%e %b: %H:%M'
};

export const GRAPH_TYPES = ['All', 'Voltage', 'Current', 'Temperature', 'Power', 'Energy'];

export const COLOUR_CODES = [
  '#2d4bff',
  '#2da2ff',
  '#2ee5ff',
  '#1effb1',
  '#05ff00',
  '#c6ff03',
  '#fcff03',
  '#fcde00',
  '#fcb101',
  '#fc5a02',
  '#fc2c04',
  '#fd0194',
  '#fe00d3',
  '#d200ff',
  '#9a02fc',
  '#4100ff',
  '#141999',
  '#1f71cc',
  '#25b3cc',
  '#22cc81',
  '#117a03',
  '#96cc09',
  '#c9cc0a',
  '#c8ae08',
  '#c88208',
  '#c63507',
  '#c60d08',
  '#c70068',
  '#77003f',
  '#960079',
  '#760099',
  '#1d0099',
  '#7a7fff',
  '#97c8ff',
  '#7dbbff',
  '#82ecff',
  '#7fffc7',
  '#7bff6a',
  '#d7ff6c',
  '#fdff6d',
  '#fce86c',
  '#fcc86c',
  '#fb8e6b',
  '#fb706c',
  '#fb66b4',
  '#fc66df',
  '#dc66ff',
  '#6d6998',
  '#828282',
  '#000000',
  '#2d4bff',
  '#2da2ff',
  '#2ee5ff',
  '#1effb1',
  '#05ff00',
  '#c6ff03',
  '#fcff03',
  '#fcde00',
  '#fcb101',
  '#fc5a02',
  '#fc2c04',
  '#fd0194',
  '#fe00d3',
  '#d200ff',
  '#9a02fc',
  '#4100ff',
  '#141999',
  '#1f71cc',
  '#25b3cc',
  '#22cc81',
  '#117a03',
  '#96cc09',
  '#c9cc0a',
  '#c8ae08',
  '#c88208',
  '#c63507',
  '#c60d08',
  '#c70068',
  '#77003f',
  '#960079',
  '#760099',
  '#1d0099',
  '#7a7fff',
  '#97c8ff',
  '#7dbbff',
  '#82ecff',
  '#7fffc7',
  '#7bff6a',
  '#d7ff6c',
  '#fdff6d',
  '#fce86c',
  '#fcc86c',
  '#fb8e6b',
  '#fb706c',
  '#fb66b4',
  '#fc66df',
  '#dc66ff',
  '#6d6998',
  '#828282',
  '#000000'
];
